<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-4 col-12 d-flex align-items-center"
          :class="{
            'col-sm-12 ': selectedRows.length > 0,
            'col-sm-4 ': selectedRows.length === 0
          }"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div
          class="col-lg-8 col-md-8 col-12 alinmov2 alinmov5"
          :class="{
            'col-sm-12': selectedRows.length > 0,
            'col-sm-8 ': selectedRows.length === 0
          }"
        >
          <div class="box-buttons">
            <base-dropdown
              v-if="selectedRows.length > 0"
              menu-on-left
              class="nav-item mr-2 p-0"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-kebab"></i>
                <strong>Actions</strong>
              </base-button>

              <div
                class="dropdown-item"
                v-if="canUserSendPaymentLink && selectedRows.length > 0"
                @click="
                  handlerSendPaymentLink(
                    selectedRows.map(item => item.reservation),
                    sendPaymentLinkToCustomer
                  )
                "
              >
                <i class="flaticon-email text-warning"></i>Send Payment Link
              </div>
              <div
                class="dropdown-item"
                v-if="selectedRows.length > 0 && canUserMarkBookingAsPaid"
                @click="
                  handlerMarkReservationsAsPaid(
                    selectedRows.map(item => item.reservation),
                    markReservationsAsPaidById
                  )
                "
              >
                <i class="flaticon-bold-check-3 text-success"></i>Mark as Paid
              </div>
              <div
                class="dropdown-item"
                @click="openShareReservationsModel(selectedRows)"
                v-if="selectedRows.length > 0"
              >
                <i class="flaticon-web-share-1"></i>Share Reservation Link
              </div>
              <div
                class="dropdown-item"
                v-if="selectedRows.length > 0 && canUserDelete"
                @click="
                  exportEventsTemplate(
                    selectedRows.map(item => item.reservation._id),
                    downloadEventsTemplate
                  )
                "
              >
                <i class="flaticon-downloading-files"></i>Download Event
                Template
              </div>
              <div
                class="dropdown-item"
                v-if="selectedRows.length > 0 && canUserDelete"
                @click="
                  bulkDeleteBookings(
                    selectedRows.map(item => item.reservation),
                    bulkDeleteBookingsByIds
                  )
                "
              >
                <i class="flaticon-delete text-danger"></i>Delete
              </div>
            </base-dropdown>

            <base-button
              v-if="canUserCreate"
              type="outline-neutral"
              class="min-button mr-2 mb-0"
              @click="goToNewQuote()"
            >
              <i class="flaticon-tools-document"></i>
              <span class="d-lg-block d-none mx-1">New </span>Quote
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              class="min-button m-0"
              @click="goToNewReservation()"
            >
              <i class="flaticon-plus"></i>
              <span class="d-lg-block d-none mx-1">New </span>Reservation
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>

                <b-input-group-append class="pt-1 pb-0">
                  <b-button
                    variant="neutro"
                    v-b-toggle.toggleFilters
                    class="p-0"
                  >
                    <i class="flaticon-equalizer"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="mt-md-0 mt-3">
                <base-button
                  type="outline-neutral mb-md-0 mb-2"
                  class="min-button mr-2"
                  v-if="query"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral mr-2 mb-md-0 mb-2"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SBC')"
                  >
                    <i class="flaticon-remove text-cancelled"></i> Cancelled
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('JF')"
                  >
                    <i class="flaticon-check text-completed"></i> Completed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SC')"
                  >
                    <i class="flaticon-bold-check-3 text-confirmed"></i>
                    Confirmed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('BI')"
                  >
                    <i class="flaticon-time-left text-draft"></i> Draft
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('EXP')"
                  >
                    <i class="flaticon-wall-clock-1 text-cancelled"></i>
                    Expired
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('NW')"
                  >
                    <i class="flaticon-add text-new"></i> New
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('NS')"
                  >
                    <i class="flaticon-no-group text-no-show"></i> No Show
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SRB')"
                  >
                    <i class="flaticon-warning-1 text-rejected"></i>
                    Rejected
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('PNDG')"
                  >
                    <i class="flaticon-wall-clock-1 text-pending"></i>
                    Pending Payment
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('RCF')"
                  >
                    <i class="flaticon-bold-check-3 text-processing"></i>
                    Reconfirm
                  </div>
                </base-dropdown>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral mr-2 mb-md-0 mb-2"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-invoice"></i>
                    <strong>Payment</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('paid')"
                  >
                    <i class="flaticon-bold-check-3 text-success"></i> Paid
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('unpaid')"
                  >
                    <i class="flaticon-wall-clock-1 text-danger"></i> Unpaid
                  </div>
                </base-dropdown>

                <base-button
                  type="outline-neutral"
                  class="min-button d-md-inline-block d-none mb-md-0 mb-2"
                  v-b-toggle.toggleFilters
                >
                  <i class="flaticon-equalizer"></i>Advanced Search
                </base-button>
              </div>
            </div>
          </div>
        </div>

        <b-collapse id="toggleFilters" class="mt-2">
          <div class="filters-advanced forms">
            <div class="card pb-2">
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-sm-4 col-12 align-self-center pb-4"
                >
                  <h4 class="underline mb-0">Filters</h4>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-8 col-12 alinmov2 align-self-center pb-4"
                >
                  <base-button
                    type="outline-neutral"
                    class="min-button mr-2"
                    v-b-toggle.toggleFilters
                  >
                    <i class="flaticon-cancel"></i>
                    Close
                  </base-button>
                  <base-button
                    type="outline-neutral"
                    class="min-button mr-2"
                    @click="resetSearchFilter()"
                  >
                    <i class="flaticon-eraser"></i> Clear
                  </base-button>
                  <base-button
                    type="primary"
                    class="min-button mb-2"
                    @click="applyAdvancedSearch"
                  >
                    Apply
                  </base-button>
                </div>
              </div>
              <div class="row formsearch">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Reservation Number"
                    v-model.trim="filters.booking_number"
                    id="search_number"
                    name="search_number"
                    label="Reservation N° / ID"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input label="Date Range">
                    <flat-pickr
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        allowInput: true,
                        mode: 'range',
                        altFormat: 'd-M-Y',
                        altInput: true,
                        dateFormat: 'Y-m-d'
                      }"
                      class="input-custom"
                      placeholder="Select Date Range"
                      v-model.trim="filters.date"
                      id="search_date"
                      name="search_date"
                      type="search"
                    ></flat-pickr>
                  </base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Invoice Number"
                    v-model.trim="filters.invoice_number"
                    id="search_invoice"
                    name="search_invoice"
                    label="Invoice Number"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="filterCustomer"
                    placeholder="Enter a customer"
                    v-model.trim="filters.customer"
                    id="search_customer"
                    name="search_customer"
                    label="Customer"
                    @change="populateCustomer"
                    clearable
                  >
                    <el-option
                      v-for="(customer, index) in customers"
                      class="select-danger"
                      :value="customer._id"
                      :label="getCustomerName(customer)"
                      :key="index"
                    >
                      <span class="hide-data-inline coin-left">{{
                        getCustomerName(customer)
                      }}</span>
                      <span class="hide-data-inline coin-right">{{
                        getUserTypeFormat(customer.type)
                      }}</span>
                    </el-option>
                  </WSelect>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12"
                  v-if="customerFilter && customerType === 'travel_agency'"
                >
                  <WSelect
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="filterAgent"
                    placeholder="Enter a Agent"
                    v-model.trim="filters.agent"
                    id="filterAgent"
                    name="filterAgent"
                    label="Agents"
                    clearable
                  >
                    <el-option
                      v-for="(agent, index) in agents"
                      class="select-danger"
                      :value="agent._id"
                      :label="`${agent.first_name} ${agent.last_name}`"
                      :key="index"
                    ></el-option>
                  </WSelect>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="First Name"
                    v-model.trim="filters.first_name"
                    id="search_firstname"
                    name="search_firstname"
                    label="Passenger First Name"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Last Name"
                    v-model.trim="filters.last_name"
                    id="search_lastName"
                    name="search_lastName"
                    label="Passenger Last Name"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Supplier"
                    v-model.trim="filters.supplier"
                    id="search_supplier"
                    name="search_supplier"
                    filterable
                    remote
                    reserve-keyword
                    label="Supplier"
                    @change="selectOperator"
                    clearable
                  >
                    <el-option
                      v-for="supplier in operatorSelections"
                      :value="supplier._id"
                      :label="supplier.businessDetails.name"
                      :key="supplier._id"
                    ></el-option>
                  </WSelect>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Enter a Destination"
                    v-model="destinationSlug"
                    id="search_branch"
                    name="search_branch"
                    filterable
                    remote
                    reserve-keyword
                    @change="selectDestinations"
                    label="Destination"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in branchesOptions"
                      :value="item.slug"
                      :label="item.name"
                      :key="index"
                    >
                      <span class="hide-data-inline coin-left">{{
                        item.name
                      }}</span>
                    </el-option>
                  </WSelect>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Reservation Reference"
                    v-model.trim="filters.booking_reference"
                    id="search_Reference"
                    name="search_Reference"
                    label="Reservation Reference"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Zoho Deal Number"
                    v-model.trim="filters.dealNumber"
                    id="deal_number"
                    name="deal_number"
                    label="Zoho Deal Number"
                    type="search"
                  ></base-input>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <base-input
                    placeholder="Payment Reference N°:"
                    v-model.trim="filters.paymentReference"
                    id="search_payment"
                    name="search_payment"
                    label="Payment Reference N°"
                    type="search"
                  ></base-input>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <WSelect
                    placeholder="Payment Type"
                    v-model.trim="filters.payment_type"
                    id="payment_type"
                    name="payment_type"
                    filterable
                    remote
                    reserve-keyword
                    label="Payment Type"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in paymentMethods"
                      :value="item.value"
                      :label="item.label"
                      :key="index"
                    ></el-option>
                  </WSelect>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                  <label for="firstBookings" class="title-label-np"
                    >First Reservation only</label
                  >

                  <base-switch
                    v-model="filters.firstBookingSwitch"
                    @input="changeFirstBookings()"
                  ></base-switch>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <div class="row">
          <div
            class="col-12 pt-0 pb-3 text-right"
            v-if="activeFilter || sortBySync"
          >
            <template v-if="activeFilter">
              <span><strong>Filtered by: </strong></span>
              <ul class="box-tags-filters">
                <li class="tags-filters" v-if="simpleSearch">
                  {{ simpleSearch }}
                </li>
                <li class="tags-filters" v-if="filters.booking_number != ''">
                  Reservation N°/ID: {{ filters.booking_number }}
                </li>
                <li class="tags-filters" v-if="filters.date">
                  Date Range: {{ filters.date }}
                </li>
                <li class="tags-filters" v-if="filters.invoice_number != ''">
                  Invoice N°:{{ filters.invoice_number }}
                </li>
                <li class="tags-filters" v-if="reservationStatus">
                  Status: {{ getReservationStatusFormat(reservationStatus) }}
                </li>
                <li class="tags-filters" v-if="customerFilter">
                  Customer: {{ customerFilter.first_name }}
                  {{ customerFilter.last_name }}
                </li>
                <li class="tags-filters" v-if="operatorFilter">
                  Supplier: {{ operatorFilter.businessDetails.name }}
                </li>
                <li class="tags-filters" v-if="branchFilter">
                  Destination: {{ branchFilter.name }}
                </li>
                <li class="tags-filters" v-if="filters.service != ''">
                  Service: {{ filters.service }}
                </li>

                <li class="tags-filters" v-if="filters.last_name != ''">
                  Passenger Last Name:{{ filters.last_name }}
                </li>
                <li class="tags-filters" v-if="filters.first_name != ''">
                  Passenger First Name: {{ filters.first_name }}
                </li>
                <li class="tags-filters" v-if="filters.booking_reference != ''">
                  Reservation Reference: {{ filters.booking_reference }}
                </li>
                <li class="tags-filters" v-if="filters.destination != ''">
                  Destination: {{ filters.destination }}
                </li>
                <li class="tags-filters" v-if="filters.paymentReference != ''">
                  Payment Reference: {{ filters.paymentReference }}
                </li>
                <li class="tags-filters" v-if="filters.dealNumber">
                  Zoho Deal Number: {{ filters.dealNumber }}
                </li>
                <li class="tags-filters" v-if="paymentStatus">
                  Payment Status: {{ getPaymentStatusFormat(paymentStatus) }}
                </li>
                <li class="tags-filters" v-if="filters.payment_type">
                  Payment Type: {{ formatPaymentType(filters.payment_type) }}
                </li>
                <li class="tags-filters" v-if="filters.firstBooking">
                  First Reservation only
                </li>
                <li class="d-inline-block">
                  <span @click="resetSearchFilter()" class="curp"
                    ><i class="flaticon-cancel ml-2"></i
                  ></span>
                </li>
              </ul>
            </template>
            <template v-if="sortBySync">
              <span class="ml-3"><strong>Local Sorted by:</strong></span>
              <ul class="box-tags-filters">
                <li class="tags-filters">
                  {{ getSortName(sortBySync, sortDescSync) }}
                </li>
                <li class="d-inline-block">
                  <span @click="restartSortAction()" class="curp"
                    ><i class="flaticon-cancel ml-2"></i
                  ></span>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model.trim="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>
                <b-form-radio value="NW"
                  >New
                  <badge type="danger" class="square" v-if="numberNew > 0">{{
                    numberNew
                  }}</badge></b-form-radio
                >

                <b-form-radio value="SRB"
                  >Rejected
                  <badge
                    type="danger"
                    class="square"
                    v-if="numberRejected > 0"
                    >{{ numberRejected }}</badge
                  ></b-form-radio
                >
                <b-form-radio value="UPMG"
                  >Upcoming
                  <badge
                    type="danger"
                    class="square"
                    v-if="numberUpcoming > 0"
                    >{{ numberUpcoming }}</badge
                  >
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-1"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Update Reservations"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="importReservationsFromCSV(uploadcsvFile)"
                >
                  <i class="flaticon-up-2 mr-0"></i>
                </base-button>
              </el-tooltip>
              <input
                ref="csvFileInput"
                type="file"
                accept=".csv"
                style="display: none"
                @change="handleCsvFileChange"
              />
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="
                      download(selectedRows.map(item => item.reservation))
                    "
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          :limit="limit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="reservations"
          :fields="fields"
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          :filter="filterOne"
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :tbody-transition-props="transProps"
          :stacked="cardview"
          :table-class="getTableClass(reservations)"
          responsive
          sticky-header
          no-sort-reset
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == reservations.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
            </template>
          </template>

          <template #thead-top="data">
            <draggable
              tag="b-tr"
              v-model="fields"
              @change="changDraggable"
              draggable=".dragg"
              sortable="true"
              :sort="true"
            >
              <b-th
                v-for="(field, index) in fields"
                :key="index"
                class="draggable text-center"
                :class="[
                  {
                    'no-drag': !field.settings.drag,
                    dragg: field.settings.drag,
                    'b-table-sort-icon-left': field.sortable
                  }
                ]"
                style="padding: 0px 10px 10px 10px !important"
                :aria-sort="sortBySync"
                :width="field.width"
              >
                <span class="drag-drop" v-if="field.settings.drag"> </span>
              </b-th>
            </draggable>
          </template>

          <template #cell(booking_number)="data">
            <div class="d-block">
              <span
                v-if="data.item.reservation.isFirstBooking"
                class="first-table-badge"
                >First Reservation</span
              >
            </div>

            <router-link :to="goToEditReservation(data.item.reservation)">
              {{ data.item.reservation.booking_number }}

              <el-tooltip
                v-if="data.item.reservation.product"
                :content="
                  data.item.class === 'Transfers'
                    ? 'RhomTrip Experience'
                    : 'Ventrata Experience'
                "
                placement="bottom"
                ><i
                  class="flaticon-tools-traveling ml-1"
                  :class="{
                    'color-primary': data.item.class === 'Transfers',
                    'text-danger': data.item.class != 'Transfers'
                  }"
                ></i
              ></el-tooltip>
            </router-link>

            <el-popover
              placement="bottom"
              trigger="hover"
              width="300"
              class="curp d-inline-flex ml-1"
              v-if="
                data.item.reservation.childSeatsCount > 0 &&
                  data.item.class === 'Transfers'
              "
            >
              <div class="p-2">
                <span>
                  <strong>Important: </strong>
                  <span class="text-min hide-data-multiple">
                    This reservation includes child seat(s). <br />
                    <br />
                    Please ensure that all requests have been confirmed with the
                    supplier and correctly added as extras.</span
                  >
                </span>
              </div>

              <div slot="reference" class="d-flex text-warning">
                <i class="flaticon-circle"></i>
              </div>
            </el-popover>
          </template>

          <template #cell(typeTransfer)="data">
            <span
              v-html="getBookingType(data.item.reservation.type)"
              v-if="data.item.class === 'Transfers'"
            ></span>
            <span v-else>-</span>
          </template>

          <template #cell(reservationtype)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span
                class="text-capitalize"
                v-if="data.item.reservation.product"
              >
                Experience
              </span>

              <span class="text-capitalize" v-else>Private Transfer</span>
            </div>
            <div v-else>
              <span class="text-capitalize">Experience</span>
            </div>
          </template>

          <template #cell(from)="data">
            <span class="multiline-3" v-if="data.item.class === 'Transfers'"
              >{{ data.item.reservation.from }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(to)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span
                class="multiline-3"
                v-if="data.item.reservation.type != 'hourly'"
              >
                {{ data.item.reservation.to }}
              </span>
              <span class="multiline-3" v-else> - </span>
            </div>

            <div v-else>
              <span class="multiline-3"> - </span>
            </div>
          </template>

          <template #cell(experienceTitle)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span v-if="data.item.reservation.product">
                {{ data.item.reservation.product.name }}
              </span>
              <span class="text-capitalize" v-else>-</span>
            </div>
            <div v-else>
              <span class="multiline-3">{{
                data.item.reservation.product.title
              }}</span>
            </div>
          </template>

          <template #cell(pickup_date)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span>
                {{ formatBookingDate(data.item.reservation.pickup_date) }}
              </span>
              <span class="d-block">
                {{ formatBookingTime(data.item.reservation.pickup_time) }}
              </span>
            </div>
            <div v-else>
              <span>
                {{ getTravelDate(data.item.reservation.availabilityId) }}
              </span>
              <span
                class="d-block"
                v-if="data.item.reservation.availabilityId.includes('T')"
              >
                {{ getStartTime(data.item.reservation.availabilityId) }}
              </span>
            </div>
          </template>

          <template #cell(passenger)="data">
            <div
              class="d-flex align-items-center"
              @click.stop="toggleDetails(data.item, data.item.bookingNumber)"
            >
              <span>
                <i
                  class="flaticon-web-down-chevron mr-2 f-10"
                  v-if="!isRowExpanded(data.item)"
                ></i>
                <i
                  class="flaticon-web-up-chevron mr-2 f-10"
                  v-if="isRowExpanded(data.item)"
                ></i>
              </span>

              <span
                class="text-capitalize"
                v-if="data.item.class === 'Transfers'"
              >
                {{
                  getPassenger(data.item.passengers, data.item.passengersCount)
                }}
              </span>

              <span class="text-capitalize" v-else>
                {{
                  getContacts(
                    data.item.reservation.contact,
                    data.item.reservation.unitItems
                  )
                }}
              </span>
            </div>
          </template>

          <template #cell(passengersCount)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span>{{ data.item.reservation.passengersCount }} </span>
            </div>
            <div v-else>
              <span
                v-html="getLabelPax(data.item.reservation.unitItems)"
              ></span>
            </div>
          </template>

          <template #cell(transportRef)="data">
            <div
              v-if="
                data.item.class === 'Transfers' &&
                  data.item.reservation.type !== 'journey'
              "
            >
              <span class="role-table">
                {{ getLabelTransport(data.item.reservation.type) }}
              </span>
              <span
                class="d-block"
                :class="{
                  uppercase:
                    data.item.reservation.type !== 'hourly' &&
                    getTransportReference(data.item.reservation)
                }"
              >
                {{ getTransportReference(data.item.reservation) || "-" }}
              </span>
            </div>

            <div v-else>
              <span>N/A</span>
            </div>
          </template>

          <template #cell(customer)="data">
            <ShowAgent
              v-if="data.item.reservation.agent"
              :agent="data.item.reservation.agent"
              :customerId="
                data.item.reservation.customer
                  ? data.item.reservation.customer._id
                  : null
              "
            />
            <ShowCustomer v-else :customer="data.item.reservation.customer" />
          </template>

          <template #row-details="data">
            <div class="table-toggle ml-4">
              <div
                class="card w-100"
                :class="{ max: data.item.reservation.passengersCount > 8 }"
              >
                <h2 class="subtitle mb-3">Pax</h2>
                <b-table
                  hover
                  :items="data.item.passengers"
                  :fields="
                    getHeaderPassengerTable(
                      FIELDS_PASSENGER_TABLE,
                      data.item.reservation.type
                    )
                  "
                  sort-by.sync="fullname"
                  sort-desc.sync="true"
                  selectable
                  @row-selected="onRowSelected"
                  select-mode="multi"
                  ref="passengertable"
                  sort-icon-left
                  responsive
                  show-empty
                  empty-filtered-text="There are no records matching your request"
                  empty-text="There are no records to show"
                >
                  <template #cell(fullname)="data">
                    <span class="text-capitalize"
                      >{{ getTitleByGender(data.item.gender) }}
                      {{ data.item.firstName }}
                      {{ data.item.lastName }}
                    </span>

                    <span
                      class="badge-status badge-default mr-2"
                      v-if="data.item.primary"
                      >Primary</span
                    >
                  </template>

                  <template #cell(phone)="data">
                    <span v-if="data.item.phone">{{ data.item.phone }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template #cell(email)="data">
                    <span class="hide-data lower" v-if="data.item.email">
                      {{ data.item.email }}
                    </span>
                    <span v-else> N/A</span>
                  </template>

                  <template #cell(itinerary)="data">
                    <span class="uppercase" v-if="data.item.flightNumber">{{
                      data.item.flightNumber
                    }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template #cell(type)="data">
                    {{ formatPassengerType(data.item.type) }}
                  </template>

                  <template #cell(notify)="data">
                    {{ data.item.notify ? "Yes" : "No" }}
                  </template>

                  <template #cell(actions)="data">
                    <el-tooltip content="Copy data" placement="bottom">
                      <span
                        class="icon-action mr-2"
                        @click.stop="copyPassengerData(data.item)"
                      >
                        <i class="flaticon-copy text-black"></i>
                      </span>
                    </el-tooltip>
                  </template>
                </b-table>
              </div>
            </div>
          </template>

          <template #cell(service)="data">
            <div v-if="data.item.class === 'Transfers'">
              <div v-if="data.item.reservation.service">
                <div class="box-img-card">
                  <div class="img-car">
                    <LazyImage
                      :src="
                        data.item.reservation.service.vehicle.information.image
                      "
                      imgClasses="img-fluid es-img-service-2"
                    />
                  </div>

                  <div class="content">
                    <span class="capitalize hide-data title">
                      {{
                        formatCategory(
                          data.item.reservation.service.vehicle.parameters
                            .category
                        )
                      }}
                    </span>

                    <span class="hide-data subtitle-1"
                      >{{
                        data.item.reservation.service.vehicle.parameters.name
                      }}
                      or Similar</span
                    >
                    <span class="hide-data subtitle-1">{{
                      formatVehicleType(
                        data.item.reservation.service.vehicle.parameters.type
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="">
              <span>-</span>
            </div>
          </template>

          <template #cell(supplier)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span class="role-table" v-if="data.item.reservation.branch">
                {{ data.item.reservation.branch.name }}
              </span>
              <a
                v-if="data.item.reservation.supplier !== null"
                class="capitalizeb break-data"
                :href="`/suppliers/${data.item.reservation.supplier._id}`"
                target="_blank"
              >
                {{ data.item.reservation.supplier.businessDetails.name }}
              </a>
            </div>
            <div v-else>
              <span class="role-table">
                {{ data.item.reservation.product.location }}
              </span>
              <a
                v-if="data.item.reservation.product.destination"
                class="capitalize break-data"
                target="_blank"
              >
                {{ data.item.reservation.product.destination.contact.name }}
              </a>
            </div>
          </template>

          <template #cell(driver)="data">
            <div v-if="data.item.class === 'Transfers'">
              <span class="capitalize break-data" v-if="data.item.driver">
                {{ data.item.driver }}
              </span>
              <span class="text-capitalize text-danger" v-else>Unassigned</span>
            </div>
            <div v-else>-</div>
          </template>

          <template #cell(referredBy)="data">
            <span v-if="data.item.referredBy">
              {{ data.item.referredBy }}
            </span>
            <span class="text-capitalize" v-else>Direct</span>
          </template>

          <template #cell(netPrice)="data">
            <span :class="data.item.netprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(quotedPrice)="data">
            <span :class="data.item.quotedPrice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.quotedPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(grossPrice)="data">
            <span :class="data.item.grossprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.grossPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netProfit)="data">
            <span :class="data.item.netprofit < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netProfit }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalExtras)="data">
            <span :class="data.item.totalExtras < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalExtras }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalDiscounts)="data">
            <span :class="data.item.totalDiscounts < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalDiscounts }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalCharge)="data">
            <span :class="data.item.totalcharge < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalCharge }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(stripeFee)="data">
            <span :class="data.item.commission < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.stripeFee }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(commission)="data">
            <span :class="data.item.commission < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.commission }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(reservation_reference)="data">
            <span v-if="data.item.reservation.booking_reference">{{
              data.item.reservation.booking_reference
            }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(deal_number)="data">
            <span v-if="data.item.reservation.deal_number"
              >{{ data.item.reservation.deal_number }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(invoice_n)="data">
            <span v-if="data.item.reservation.invoice_number"
              >{{ data.item.reservation.invoice_number }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(payment_reference)="data">
            <span v-if="data.item.reservation.payment_reference"
              >{{ data.item.reservation.payment_reference }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(source_channel)="data">
            <span class="text-capitalize hide-data">
              {{ data.item.reservation.source.origin }}</span
            >
          </template>

          <template #cell(source_provider)="data">
            <span class="text-capitalize hide-data">
              {{ getSourceProvider(data.item.reservation.source) }}</span
            >
          </template>

          <template #cell(payment)="data">
            <PaymentStatus
              :payment="data.item.reservation.payment"
              :paymentLinkStatus="data.item.reservation.send_payment_link"
              :paymentLink="data.item.reservation.payment_link"
              :paymentType="data.item.reservation.payment_type"
              :status="data.item.reservation.status"
            />
          </template>

          <template #cell(status)="data">
            <div v-if="data.item.class === 'Transfers'">
              <el-popover
                placement="top"
                trigger="hover"
                width="230"
                v-if="
                  showPopover(
                    data.item.reservation.status,
                    data.item.reservation.created_at,
                    data.item.reservation.status_update,
                    data.item.reservation.pickup_date,
                    data.item.reservation.branch.timezone
                  )
                "
              >
                <span class="text-center d-block">{{
                  getStatusMessage(
                    data.item.reservation.status,
                    data.item.reservation.created_at,
                    data.item.reservation.status_update,
                    data.item.reservation.pickup_date,
                    data.item.reservation.branch.timezone,
                    data.item.reservation.rate.status,
                    data.item.reservation.rate.utcExpiresAt
                  )
                }}</span>

                <div
                  slot="reference"
                  class="badge-status"
                  v-bind:class="
                    getStatusClass(
                      data.item.reservation.status,
                      data.item.reservation.created_at,
                      data.item.reservation.status_update,
                      data.item.reservation.pickup_date,
                      data.item.reservation.branch.timezone,
                      data.item.reservation.rate.status
                    )
                  "
                >
                  {{
                    getLabelStatus(
                      data.item.reservation.status,
                      data.item.reservation.status_update,
                      data.item.reservation.rate.status
                    )
                  }}
                </div>
              </el-popover>

              <div
                v-else
                class="badge-status"
                v-bind:class="statusValue(data.item.reservation.status)"
              >
                {{ getReservationStatusFormat(data.item.reservation.status) }}
              </div>
            </div>
            <div v-else>
              <div
                class="badge-status"
                v-bind:class="statusValue(data.item.reservation.status)"
              >
                {{ getReservationStatusFormat(data.item.reservation.status) }}
              </div>
              <el-popover
                placement="top"
                trigger="hover"
                width="80"
                class="curp"
                v-if="data.item.reservation.status === 'ON_HOLD'"
              >
                <span class="text-center d-block w-100"> Expiration time </span>
                <div slot="reference">
                  <div
                    class="d-flex justify-content-center align-items-center mt-1"
                  >
                    <Countdown
                      :date="data.item.reservation.utcExpiresAt"
                      type="sm"
                    />
                  </div>
                </div>
              </el-popover>
            </div>
          </template>

          <template #cell(actions)="data">
            <div v-if="data.item.class === 'Transfers'">
              <div class="action-column">
                <div class="button-action mr-2">
                  <el-tooltip
                    content="History"
                    placement="bottom"
                    class="d-inline-flex"
                  >
                    <span
                      class="icon-action text-blue"
                      @click.stop="
                        openReservationHistory(
                          data.item.reservation._id,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <i class="flaticon-wall-clock-1"> </i>
                    </span>
                  </el-tooltip>
                </div>
                <div class="drop-action d-inline-block">
                  <base-dropdown
                    menu-on-right
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="dropnocaret"
                    title="Actions"
                    :direction="getDirection(reservations, data.index)"
                  >
                    <span slot="title">
                      <i class="flaticon-bold-kebab"></i
                    ></span>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          canConfirmBooking(
                            data.item.reservation.status,
                            data.item.reservation.status_update,
                            data.item.reservation.owner
                          )
                      "
                      @click="
                        confirmBooking(
                          data.item.reservation._id,
                          confirmReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-bold-check-3 text-confirmed"> </i>
                        Confirm
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          canCancelBooking(data.item.reservation.status)
                      "
                      @click="
                        handlerCancelReservation(
                          data.item.reservation._id,
                          data.item.reservation.pickup_date,
                          data.item.reservation.branch.timezone,
                          data.item.reservation.service.cancellationPolicy,
                          cancelReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-remove text-cancelled"></i> Cancel
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          canCompleteBooking(data.item.reservation.status) &&
                          calculateHoursDifference(
                            data.item.reservation.pickup_date,
                            data.item.reservation.branch.timezone
                          ) >= 1
                      "
                      @click="
                        completeBooking(
                          data.item.reservation._id,
                          updateBookingStatus
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-check text-completed"></i> Complete
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          canMarkBookingAsNoShow(
                            data.item.reservation.status
                          ) &&
                          calculateHoursDifference(
                            data.item.reservation.pickup_date,
                            data.item.reservation.branch.timezone
                          ) >= 1
                      "
                      @click="
                        noShowBooking(
                          data.item.reservation._id,
                          updateBookingStatus
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-no-group text-no-show"></i> Mark as
                        No Show
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserMarkBookingAsPaid &&
                          canMarkBookingAsPaid(
                            data.item.reservation.status,
                            data.item.reservation.payment,
                            data.item.reservation.rate.status
                          )
                      "
                      @click="
                        handlerMarkReservationsAsPaid(
                          [data.item.reservation],
                          markReservationsAsPaidById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-invoice text-confirmed"></i> Mark as
                        Paid
                      </span>
                    </div>

                    <div
                      class="dropdown-divider"
                      v-if="data.item.reservation.status != 'JF'"
                    ></div>

                    <div
                      class="dropdown-item"
                      v-if="canResendBookingEmail(data.item.reservation.status)"
                      @click="
                        resendNotifications(
                          data.item.reservation._id,
                          data.item.reservation.status,
                          data.item.reservation.class,
                          data.item.reservation.isProssesing,
                          resendEmailNotificationByBookingId
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-envelope text-orange"></i> Resend
                        Email
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="canDownloadQuote(data.item.reservation.status)"
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'quote',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i>Download Quote
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="canDownloadVoucher(data.item.reservation.status)"
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'voucher',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i>Download Voucher
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      @click="
                        canUserCreate &&
                          duplicateBooking(
                            data.item.reservation._id,
                            duplicateBookingById
                          )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-copy"></i>Duplicate
                      </span>
                    </div>

                    <div class="dropdown-divider"></div>

                    <div
                      class="dropdown-item"
                      v-if="canUserDelete"
                      @click="
                        deleteBooking(
                          data.item.reservation._id,
                          deleteBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-delete text-danger"></i>Delete
                      </span>
                    </div>
                  </base-dropdown>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="action-column">
                <div class="button-action mr-2">
                  <el-tooltip
                    content="History"
                    placement="bottom"
                    class="d-inline-flex"
                  >
                    <span
                      class="icon-action text-blue"
                      @click.stop="
                        openReservationHistory(
                          data.item.reservation._id,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <i class="flaticon-wall-clock-1"> </i>
                    </span>
                  </el-tooltip>
                </div>
                <div class="drop-action d-inline-block">
                  <base-dropdown
                    menu-on-right
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="dropnocaret"
                    title="Actions"
                    :direction="getDirection(reservations, data.index)"
                  >
                    <span slot="title">
                      <i class="flaticon-bold-kebab"></i
                    ></span>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          ['ON_HOLD'].includes(data.item.reservation.status)
                      "
                      @click="
                        confirmBooking(
                          data.item.reservation._id,
                          otaConfirmReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-bold-check-3 text-confirmed"> </i>
                        Confirm
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserMarkBookingAsPaid &&
                          canMarkBookingAsPaid(
                            data.item.reservation.status,
                            data.item.reservation.payment,
                            false
                          )
                      "
                      @click="
                        handlerMarkReservationsAsPaid(
                          [data.item.reservation],
                          markReservationsAsPaidById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-invoice text-confirmed"></i> Mark as
                        Paid
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserChangeStatus &&
                          ['ON_HOLD', 'CONFIRMED'].includes(
                            data.item.reservation.status
                          )
                      "
                      @click.stop="
                        otaCancelBooking(
                          data.item.reservation._id,
                          otaCancelBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-remove text-cancelled"></i> Cancel
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        ['CONFIRMED'].includes(data.item.reservation.status)
                      "
                      @click="
                        resendNotifications(
                          data.item.reservation._id,
                          data.item.reservation.status,
                          data.item.reservation.class,
                          false,
                          resendEmailNotificationByBookingId
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-envelope text-orange"></i> Resend
                        Email
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        ['CONFIRMED'].includes(data.item.reservation.status)
                      "
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'voucher',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i> Download Voucher
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        ['CONFIRMED'].includes(data.item.reservation.status)
                      "
                      @click.stop="
                        downloadTickets(
                          data.item.reservation._id,
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-tickets"></i> Download Tickets
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canUserDelete &&
                          ['CANCELLED', 'EXPIRED'].includes(
                            data.item.reservation.status
                          )
                      "
                      @click="
                        deleteBooking(
                          data.item.reservation._id,
                          deleteBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-delete text-danger"></i>Delete
                      </span>
                    </div>
                  </base-dropdown>
                </div>
              </div>
            </div>
          </template>
        </b-table>
        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          v-model="currentPage"
          :limit="limit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
    <ManageTableColumns
      :value="modalManageColumn"
      :fields="fields"
      :tableGridConfig="tableGridConfig"
      :mandatories="['booking_number']"
      @saveColumns="saveColumnsInUserAccount"
      @closeTableGridModal="closeTableGridModal"
    />
    <ReservationHistory
      :show="showReservationHistory"
      :tempReservationId="tempReservationId"
      :bookingNumber="tempBookingNumber"
      @close="closeReservationHistoryModal"
    />
    <ShareReservations
      :show="showShareReservations"
      :reservations="selectedReservationsToShare"
      @close="closeShareReservationsModal"
    />
  </section>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment-timezone";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  ReservationsAPI,
  PartnersAPI,
  SettingsAPI,
  BranchesAPI,
  DocumentsAPI,
  ExportAPI
} from "../../../core/api";
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { DropdownMenu, DropdownItem, Dropdown, MessageBox } from "element-ui";
import Pusher from "pusher-js";
import WSelect from "@/components/Select";
import PaymentStatus from "../components/PaymentStatus";
import ShowCustomer from "../../../components/clients/ShowCustomer.vue";
import ShowAgent from "../../../components/clients/ShowAgent.vue";
import ManageTableColumns from "@/components/ManageTableColumns";
import lodash from "lodash";
import ReservationHistory from "../components/ReservationHistory";
import Countdown from "@/components/Countdown.vue";
import ShareReservations from "../components/ShareReservations.vue";
import {
  bulkDeleteBookings,
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canConfirmBooking,
  canDownloadQuote,
  canDownloadVoucher,
  canMarkBookingAsNoShow,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  completeBooking,
  confirmBooking,
  deleteBooking,
  duplicateBooking,
  hasBookingsWithPaymentLink,
  hasCanceledBookings,
  hasCompletedBookings,
  hasDraftBookings,
  hasExperiencesBookings,
  hasExpiredBookings,
  hasPaidBookings,
  isSameUserForAllBookings,
  markReservationsAsPaid,
  noShowBooking,
  otaCancelBooking,
  PAYMENT_METHODS,
  removeTransferExcludedAttributes,
  resendNotifications,
  sendPaymentLink,
  getLabelTransport,
  getTransportReference,
  importReservationsFromCSV,
  exportEventsTemplate,
  resolveRefundEligibility
} from "../../../helpers/reservation.helpers";
import {
  goBack,
  isUserAuthorized,
  ROLE_HIERARCHY,
  setSigOut
} from "../../../helpers/commons.helpers";
import {
  FIELDS_PASSENGER_TABLE,
  RESERVATION_TABLE_DEFAULTS
} from "../../../core/constants";
import {
  formatBookingDate,
  formatBookingTime,
  formatPassengerType,
  formatPaymentType
} from "../services/format.service";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Reservations",
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [MessageBox.name]: MessageBox,
    DropdownPlugin,
    TablePlugin,
    WSelect: WSelect,
    flatPickr,
    PaymentStatus: PaymentStatus,
    ShowCustomer: ShowCustomer,
    ShowAgent: ShowAgent,
    draggable,
    ManageTableColumns: ManageTableColumns,
    ReservationHistory: ReservationHistory,
    Countdown: Countdown,
    ShareReservations: ShareReservations
  },

  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      pusher: null,
      filterOne: null,
      simpleSearch: "",
      filters: {
        booking_number: "",
        date: "",
        invoice_number: "",
        customer: "",
        agent: "",
        supplier: "",
        branch: [],
        service: "",
        last_name: "",
        first_name: "",
        booking_reference: "",
        destination: "",
        paymentReference: "",
        payment_type: "",
        dealNumber: "",
        firstBooking: "", // string para el API
        firstBookingSwitch: false // boolean para el switch
      },
      customers: [],
      filterStatus: "all",
      activeFilter: false,
      transProps: {
        name: "flip-list"
      },
      reservationStatus: "",
      paymentStatus: "",
      query: "",
      queryTemp: "",
      customerFilter: null,
      operatorFilter: null,
      branchFilter: null,
      numberNew: 0,
      numberRejected: 0,
      numberUpcoming: 0,
      sortBy: "",
      sortDesc: "desc",
      sortOptions: [
        {
          value: "booking_number",
          text: "Reservation N°/ID"
        },
        {
          value: "flightNumber",
          text: "Flight Number"
        },
        {
          value: "from",
          text: "From"
        },
        {
          value: "pickup_date",
          text: "Date & Time"
        },
        {
          value: "invoice",
          text: "Invoice N°"
        },
        {
          value: "passenger",
          text: "Passenger"
        },
        {
          value: "passengersCount",
          text: "N° Passengers"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "payment",
          text: "Payment"
        },
        {
          value: "typeTransfer,",
          text: "Type Transfer,"
        },
        {
          value: "to",
          text: "To"
        },
        {
          value: "created_at",
          text: "Created At"
        }
      ],
      paymentMethods: PAYMENT_METHODS,
      customerType: "customer",
      optionsAgents: [],
      agents: [],
      timeoutId: null,
      cardview: false,
      view: "table",
      modalManageColumn: false,
      fields: [],
      tableGridConfig: RESERVATION_TABLE_DEFAULTS,
      visibleSideBar: false,
      branchesOptions: [],
      destinationSlug: "",
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      guides: [],
      loader: false,
      sortBySync: "",
      sortDescSync: false,
      expandedRow: null,
      FIELDS_PASSENGER_TABLE,
      modalShareReservations: false,
      progressLoaderShare: false,
      loadingShare: true,
      selectedReservationsToShare: [],
      showShareReservations: false
    };
  },
  watch: {
    sortDescSync: {
      handler: async function(current, old) {
        await this.changeSortDescSync(current);
      },
      deep: true
    },
    sortBySync: {
      handler: async function(current, old) {
        await this.changeSortByAsync(current);
      },
      deep: true
    },
    query: {
      handler: async function(current, old) {
        await this.changeQuery(current);
      },
      deep: true
    },
    customerOptions: {
      handler: function(current, old) {
        this.customers = current.filter(customer => {
          return customer.type !== "travel_access";
        });
      },
      deep: true
    }
  },
  async created() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.fields = this.populateFiles(this.settings);
    this.sortBySync = this.getSortBySync(this.settings);
    this.sortDescSync = this.getSortDescSync(this.settings);
    this.query = this.getQuery(this.settings);

    this.subscribe("reservations");
    this.getSesion();
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Reservations",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    await this.initFilters(this.query);
    this.limit = this.paginationLimit;
    this.queryTemp = this.tempPagination.status
      ? this.tempPagination.queryTemp
      : "";
    this.filterStatus = this.tempPagination.status
      ? this.tempPagination.filteredTabStatus
      : "all";
    this.currentPage = this.tempPagination.status
      ? this.tempPagination.currentPage
      : 1;
    this.get(
      true,
      this.limit,
      this.currentPage,
      this.queryTemp ? this.queryTemp : this.query
    );
    await this.getMetadata(this.query);
    await this.initDataSelection();
  },
  methods: {
    canConfirmBooking,
    confirmBooking,
    canCancelBooking,
    canCompleteBooking,
    calculateHoursDifference,
    noShowBooking,
    canMarkBookingAsNoShow,
    canMarkBookingAsPaid,
    canResendBookingEmail,
    canDownloadQuote,
    canDownloadVoucher,
    bulkDeleteBookings,
    duplicateBooking,
    deleteBooking,
    sendPaymentLink,
    otaCancelBooking,
    resendNotifications,
    completeBooking,
    formatPaymentType,
    formatPassengerType,
    formatBookingDate,
    formatBookingTime,
    getLabelTransport,
    getTransportReference,
    importReservationsFromCSV,
    exportEventsTemplate,
    async initDataSelection() {
      this.customers = this.customerOptions.filter(customer => {
        return customer.type !== "travel_access";
      });
      await this.initSupplierInformation(
        this.filters.supplier,
        this.filters.branch
      );
      await this.populateCustomer(this.filters.customer);
      this.activeFilter = this.query ? true : false;
    },
    populateCustomer(customerId) {
      if (customerId) {
        let customer = this.customers.find(
          customer => customer._id === customerId
        );
        if (customer) {
          this.getOptionsAgentsByCustomerId(customer._id);
          this.customerFilter = customer;
        }
        this.customerType = customer ? customer.type : "customer";
      } else {
        this.customers = this.customerOptions;
      }
    },
    populateOperator(operatorId) {
      let operator = this.operatorSelections.find(
        operator => operator._id === operatorId
      );
      this.operatorFilter = operator ? operator : null;
    },
    populateDestination(branches = []) {
      let destination = this.branchesOptions.find(destination =>
        lodash.isEqual(destination.branches.sort(), branches.sort())
      );
      this.branchFilter = destination ? destination : null;
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async filteredTab(value) {
      if (value === "all") {
        this.currentPage = 1;
        this.queryTemp = "";
        await this.get(true, this.limit, this.currentPage, this.query);
      } else if (value === "NW") {
        this.currentPage = 1;
        this.queryTemp = this.addElementInQuery(this.query, "status", value);
        await this.filterByReservationStatus(this.queryTemp);
      } else if (value === "SRB") {
        this.currentPage = 1;
        this.queryTemp = this.addElementInQuery(this.query, "status", value);
        await this.filterByReservationStatus(this.queryTemp);
      } else {
        this.currentPage = 1;
        this.queryTemp = this.addElementInQuery(this.query, "upcoming", value);
        await this.filterByStatusPayment(this.queryTemp);
      }
    },
    deleteEmptyElements(query) {
      return query
        .toString()
        .split("&")
        .filter(element => {
          let [key, value] = element.split("=");
          return key && value ? true : false;
        })
        .join("&");
    },
    async applyAdvancedSearch() {
      this.filterStatus = "all";
      let searchParams = this.buildParams({
        ...Object.fromEntries(new URLSearchParams(this.query)),
        ...this.filters
      });
      if (searchParams) {
        this.query = this.deleteEmptyElements(searchParams.toString());
        this.activeFilter = this.query ? true : false;
        await this.get(true, this.limit, this.currentPage, this.query);
        await this.getMetadata(this.query);
      }
    },
    async filterByReservationStatus(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async filterByStatusPayment(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async applyFilterByReservationStatus(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.reservationStatus = status;
      this.query = this.addElementInQuery(this.query, "status", status);
      await this.filterByReservationStatus(this.query);
      await this.getMetadata(this.query);
    },
    async applyFilterByStatusPayment(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.paymentStatus = status;
      this.query = this.addElementInQuery(this.query, "payment", status);
      await this.filterByStatusPayment(this.query);
      await this.getMetadata(this.query);
    },
    async initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        this.sortBy = searchParams.has("sortBy")
          ? searchParams.get("sortBy")
          : "";
        this.sortType = searchParams.has("sortType")
          ? searchParams.get("sortType")
          : "";
        this.filters.booking_number = searchParams.has("booking_number")
          ? searchParams.get("booking_number")
          : "";
        this.filters.date = searchParams.has("date")
          ? searchParams.get("date")
          : "";
        this.filters.invoice_number = searchParams.has("invoice_number")
          ? searchParams.get("invoice_number")
          : "";
        this.filters.customer = searchParams.has("customer")
          ? searchParams.get("customer")
          : "";
        this.filters.agent = searchParams.has("agent")
          ? searchParams.get("agent")
          : "";
        this.filters.supplier = searchParams.has("supplier")
          ? searchParams.get("supplier")
          : "";
        this.filters.branch = searchParams.has("branch")
          ? searchParams.getAll("branch")
          : [];
        this.filters.service = searchParams.has("service")
          ? searchParams.get("service")
          : "";
        this.filters.last_name = searchParams.has("last_name")
          ? searchParams.get("last_name")
          : "";
        this.filters.first_name = searchParams.has("first_name")
          ? searchParams.get("first_name")
          : "";
        this.filters.booking_reference = searchParams.has("booking_reference")
          ? searchParams.get("booking_reference")
          : "";
        this.filters.destination = searchParams.has("destination")
          ? searchParams.get("destination")
          : "";
        this.filters.paymentReference = searchParams.has("paymentReference")
          ? searchParams.get("paymentReference")
          : "";
        this.simpleSearch = searchParams.has("search")
          ? searchParams.get("search")
          : "";
        this.reservationStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";

        this.paymentStatus = searchParams.has("payment")
          ? searchParams.get("payment")
          : "";

        this.filters.payment_type = searchParams.has("payment_type")
          ? searchParams.get("payment_type")
          : "";
        this.filters.dealNumber = searchParams.has("dealNumber")
          ? searchParams.get("dealNumber")
          : "";
        this.filters.firstBooking = searchParams.has("firstBooking")
          ? searchParams.get("firstBooking")
          : "";
      }
    },
    async resetSearchFilter() {
      this.destinationSlug = "";
      this.filters.booking_number = "";
      this.filters.date = "";
      this.filters.invoice_number = "";
      this.filters.customer = "";
      this.filters.agent = "";
      this.filters.supplier = "";
      this.filters.branch = [];
      this.filters.service = "";
      this.filters.last_name = "";
      this.filters.first_name = "";
      this.filters.booking_reference = "";
      this.filters.destination = "";
      this.filters.paymentReference = "";
      this.filters.payment_type = "";
      this.filters.dealNumber = "";
      this.filters.firstBooking = "";
      this.filters.firstBookingSwitch = false;
      this.filterStatus = "all";
      this.activeFilter = false;
      this.query = "";
      this.currentPage = 1;
      this.simpleSearch = "";
      this.paymentStatus = "";
      this.reservationStatus = "";
      this.customerFilter = null;
      this.operatorFilter = null;
      await this.get(true, this.limit, this.currentPage, this.query);
      await this.getMetadata(this.query);
    },
    subscribe(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, async data => {
        if (ROLE_HIERARCHY.includes(this.sesion.role)) {
          if (data.reservation.owner === "admin") {
            this.get(
              false,
              this.limit,
              this.currentPage,
              this.filterStatus === "all" ? this.query : this.queryTemp
            );
            await this.getMetadata(this.query);
            this.showNotify(data.action);
          }
        }
      });
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        if (this.filterStatus === "all") {
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.get(true, this.limit, this.currentPage, this.queryTemp);
        }
      }
    },
    previousPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    nextPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changePage(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    async download(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVReservations(
          this.queryTemp ? this.queryTemp : this.query,
          { reservations: reservations },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reservations.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data wasn't download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data wasn't download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    getCustomerName(customer) {
      if (customer) {
        if (["business", "travel_agency"].indexOf(customer.type) > -1) {
          return customer.company_name
            ? customer.company_name
            : `${customer.first_name} ${customer.last_name}`;
        } else {
          return `${customer.first_name} ${customer.last_name}`;
        }
      } else {
        return "unknown";
      }
    },
    get(loader, limit, page, query) {
      this.getReservations({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    showNotify(action) {
      if (action === "deleted") {
        this.$notify({
          type: "success",
          title: "Deleted!",
          message: "The Reservation has been Deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "canceled") {
        this.$notify({
          type: "success",
          title: "Cancelled!",
          message: "The Reservation has been cancelled",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The reservations has been created",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    getDifference(createdAt) {
      return moment(moment().format()).diff(
        moment(createdAt).format(),
        "hours",
        true
      );
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.activeFilter = true;
        if (value) {
          if (this.filterStatus === "all") {
            this.query = this.addElementInQuery(this.query, "search", value);
            await this.get(true, this.limit, this.currentPage, this.query);
            await this.getMetadata(this.query);
          } else {
            let query = this.addElementInQuery(this.queryTemp, "search", value);
            await this.get(true, this.limit, this.currentPage, query);
          }
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, this.currentPage, this.query);
          await this.getMetadata(this.query);
        }
      }, 500);
    },
    filterCustomer(input = "") {
      if (input !== "" && input.length > 2) {
        this.customers = this.customerOptions
          .filter(customer => {
            return customer.type !== "travel_access";
          })
          .filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
              customer.last_name.toLowerCase().indexOf(input.toLowerCase()) >
                -1 ||
              customer.first_name.toLowerCase().indexOf(input.toLowerCase()) >
                -1 ||
              customer.company_name.toLowerCase().indexOf(input.toLowerCase()) >
                -1
            );
          });
      } else {
        this.customers = this.customerOptions;
      }
    },
    filterAgent(input = "") {
      if (input !== "" && input.length > 2) {
        this.agents = this.optionsAgents.filter(agent => {
          let name = `${agent.first_name} ${agent.last_name}`;
          return (
            agent.full_name.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            agent.last_name.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            name.toLowerCase().indexOf(input.toLowerCase()) > -1
          );
        });
      } else {
        this.agents = this.optionsAgents;
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async getMetadata(query) {
      try {
        let { data } = await ReservationsAPI.getMetadataReservations(
          query,
          this.sesion.token
        );
        if (data.status) {
          let metadata = data.data;
          this.numberNew = metadata.new;
          this.numberRejected = metadata.rejected;
          this.numberUpcoming = metadata.numberUpcoming;
        } else {
          this.numberNew = 0;
          this.numberRejected = 0;
          this.numberUpcoming = 0;
        }
      } catch (error) {
        this.numberNew = 0;
        this.numberRejected = 0;
        this.numberUpcoming = 0;
      }
    },
    async applySortBy(value) {
      if (this.filterStatus === "all") {
        if (value) {
          this.query = this.addElementInQuery(this.query, "sortBy", value);
          this.query = this.addElementInQuery(
            this.query,
            "sortType",
            this.sortDesc
          );
        } else {
          this.sortDesc = "desc";
          this.query = this.deleteItemInQuery(this.query, [
            "sortBy",
            "sortType"
          ]);
        }
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        if (value) {
          this.queryTemp = this.addElementInQuery(
            this.queryTemp,
            "sortBy",
            value
          );
          this.queryTemp = this.addElementInQuery(
            this.queryTemp,
            "sortType",
            this.sortDesc
          );
        } else {
          this.sortDesc = "desc";
          this.queryTemp = this.deleteItemInQuery(this.queryTemp, [
            "sortBy",
            "sortType"
          ]);
        }
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async applySortType(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortType", value);
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          value
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async getOptionsAgentsByCustomerId(customerId) {
      try {
        let { data } = await PartnersAPI.getOptionsAgentsByAgencyId(
          customerId,
          this.sesion.token
        );
        if (data.status) {
          this.optionsAgents = data.data;
          this.agents = this.optionsAgents;
        } else {
          this.optionsAgents = [];
          this.agents = [];
        }
      } catch (error) {
        this.optionsAgents = [];
        this.agents = [];
      }
    },
    buildParams(data) {
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(item =>
            params.append(key, item ? item.toString() : "")
          );
        } else {
          params.append(key, value ? value.toString() : "");
        }
      });
      return params.toString();
    },
    getDirection: function(reservations = [], index) {
      if (reservations.length >= 5) {
        let position = reservations.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getTableClass(reservations = []) {
      return reservations.length < 7
        ? "b-table-separator main-table"
        : "main-table";
    },
    goToNewReservation() {
      this.setDuplicatedReservation(null);
      this.$router.push("/reservations/new");
    },
    getUserId(user) {
      if (user) {
        return typeof user === "string" ? user : user._id;
      } else {
        return null;
      }
    },
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.tableLayouts": this.fields }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.reservations.tableLayouts.length > 0) {
            return settings.reservations.tableLayouts;
          }
        }
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    async initSupplierInformation(supplier, branches = []) {
      await this.getOperatorsOptions();
      this.populateOperator(supplier);
      this.branchesOptions = await this.getBranchesOptionsToFilters(null);
      this.destinationSlug = this.getDestinationSlugByBranches(
        this.branchesOptions,
        branches
      );
      this.populateDestination(branches);
    },
    async selectOperator(operatorId) {
      if (operatorId) {
        let operator = this.operatorSelections.find(
          operator => operator._id === operatorId
        );
        this.operatorFilter = operator ? operator : null;
      } else {
        this.operatorFilter = null;
      }
    },
    selectDestinations(slug) {
      if (slug) {
        let destination = this.branchesOptions.find(
          destination => destination.slug === slug
        );
        if (destination) {
          this.filters.branch = destination.branches;
          this.branchFilter = destination;
        } else {
          this.filters.branch = [];
          this.branchFilter = null;
        }
      } else {
        this.filters.branch = [];
        this.branchFilter = null;
      }
    },
    async getBranchesOptionsToFilters(operatorId) {
      try {
        let { data } = await BranchesAPI.getBranchesOptionsToFilters(
          operatorId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getDestinationSlugByBranches(destinations = [], branches = []) {
      let destination = destinations.find(destination => {
        return lodash.isEqual(destination.branches.sort(), branches.sort());
      });
      if (destination) {
        return destination.slug;
      } else {
        return "";
      }
    },
    openReservationHistory(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "RESERVATIONS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getPassenger(passengers = [], passengersCount) {
      if (!lodash.isEmpty(passengers)) {
        let [passenger] =
          passengers.filter(passenger => passenger.primary) || passengers;
        if (passenger) {
          return `${passenger.fullName} ${
            passengersCount === 1 ? "" : `+ ${passengersCount - 1}`
          }`;
        }
      }
      return "Unassigned";
    },
    formatStatus(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending";
      } else {
        return "Draft";
      }
    },
    getStatusPayment(
      payment,
      paymentType,
      paymentLinkStatus,
      reservationStatus
    ) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "Paid";
        } else {
          return "Paid";
        }
      } else {
        if (paymentType == "credit") {
          if (reservationStatus !== "PNDG") {
            return "On credit";
          } else {
            return "Unpaid";
          }
        } else {
          return "Unpaid";
        }
      }
    },
    getSortBySync(settings) {
      try {
        if (settings) {
          if (settings.reservations.sortBySync) {
            return settings.reservations.sortBySync;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    getQuery(settings) {
      try {
        if (settings) {
          if (settings.reservations.query) {
            return settings.reservations.query;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } catch (error) {
        return "";
      }
    },
    async changeSortByAsync(sortBySync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.sortBySync": sortBySync }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    async changeQuery(query) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.query": query }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    getSortDescSync(settings) {
      try {
        if (settings) {
          if (settings.reservations.sortBySync) {
            return settings.reservations.sortDescSync;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async changeSortDescSync(sortDescSync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.reservations.sortDescSync": sortDescSync }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    getPaymentStatusFormat(status) {
      if (status === "unpaid") {
        return "Unpaid";
      } else {
        return "Paid";
      }
    },
    getUserTypeFormat(type) {
      if (type === "admin") {
        return "Admin";
      } else if (type === "driver") {
        return "Driver";
      } else if (type === "suppliers") {
        return "Supplier";
      } else if (type === "customer") {
        return "Customer";
      } else if (type === "ote") {
        return "OTE";
      } else if (type === "travel_agency") {
        return "Travel Agency";
      } else if (type === "business") {
        return "Business";
      } else if (type === "guest") {
        return "Guest";
      } else {
        return "Client";
      }
    },
    getBookingType(type) {
      if (type === "airport") {
        return "Airport Transfer";
      } else if (type === "arrival") {
        return "Airport Transfer<br>(Arrival)";
      } else if (type === "departure") {
        return "Airport Transfer<br>(Departure)";
      } else if (type === "station") {
        return "Station Transfer";
      } else if (type === "port") {
        return "Port Transfer";
      } else if (type === "hourly") {
        return "Hourly";
      } else if (type === "journey") {
        return "Journey";
      }
    },
    restartSortAction() {
      this.sortBySync = "";
      this.sortDescSync = false;
    },
    getSortName(sortBy, sortDesc) {
      let sort = this.fields.find(option => option.key === sortBy);
      if (sort) {
        return `${sort.label} - ${sortDesc ? "Descending" : "Ascending"}`;
      } else {
        return "None";
      }
    },
    getPriceFormat(price) {
      return parseFloat(price.toFixed(2));
    },
    getLabelStatus(currentStatus, statusUpdate, rateStatus) {
      if (currentStatus === "SC") {
        return statusUpdate
          ? "Reconfirm"
          : this.getReservationStatusFormat(currentStatus);
      } else if (currentStatus === "PNDG") {
        return rateStatus
          ? "Expired"
          : this.getReservationStatusFormat(currentStatus);
      } else {
        return this.getReservationStatusFormat(currentStatus);
      }
    },
    getReservationStatusFormat(status) {
      if (status === "NW") {
        return "New";
      } else if (["CANCELLED", "SBC", "SCB"].includes(status)) {
        return "Cancelled";
      } else if (["CONFIRMED", "SC"].includes(status)) {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (["ON_HOLD", "PNDG"].includes(status)) {
        return "Pending Payment";
      } else if (["EXPIRED", "EXP"].includes(status)) {
        return "Expired";
      } else if (status === "RCF") {
        return "Reconfirm";
      } else {
        return "Draft";
      }
    },
    statusValue(status) {
      if (status === "NW") {
        return "status-new";
      } else if (["CONFIRMED", "SC"].includes(status)) {
        return "status-confirmed";
      } else if (["SCB", "SBC", "CANCELLED"].includes(status)) {
        return "status-cancelled";
      } else if (status === "SRB") {
        return "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(status)) {
        return "status-started";
      } else if (status === "JF") {
        return "status-completed";
      } else if (status === "NS") {
        return "status-noshow";
      } else if (status === "BI") {
        return "status-draft";
      } else if (["PNDG", "ON_HOLD"].includes(status)) {
        return "status-draft";
      } else if (["EXPIRED"].includes(status)) {
        return "status-expired";
      } else {
        return {};
      }
    },
    showPopover(currentstatus, createdAt, statusUpdate, pickupDate, timeZone) {
      let cutOff = this.isWithin72Hours(pickupDate, timeZone);
      if (currentstatus === "NW") {
        let diff = this.getDifference(createdAt) >= 48;
        if (cutOff) {
          return true;
        } else {
          if (diff) {
            return true;
          } else {
            return statusUpdate ? true : false;
          }
        }
      } else if (currentstatus === "SC") {
        return statusUpdate;
      } else if (currentstatus === "PNDG") {
        return true;
      } else if (currentstatus === "SRB") {
        return cutOff ? true : false;
      } else {
        return false;
      }
    },
    getStatusMessage(
      currentStatus,
      createdAt,
      statusUpdate,
      pickupDate,
      timeZone,
      rateStatus,
      utcExpiresAt
    ) {
      let cutOff = this.isWithin72Hours(pickupDate, timeZone);
      if (currentStatus === "NW") {
        let diff = this.getDifference(createdAt) >= 48;
        return this.getPopoverMessageToReservationInNewStatus(
          cutOff,
          diff,
          statusUpdate,
          createdAt,
          pickupDate,
          timeZone
        );
      } else if (currentStatus === "SC") {
        return this.getPopoverMessageToReservationInConfirmedStatus(
          statusUpdate,
          cutOff,
          pickupDate,
          timeZone
        );
      } else if (currentStatus === "PNDG") {
        return rateStatus
          ? "The quote period for this reservation has expired. You can resume the reservation once it has been re-quoted."
          : `Payment is required from the partner before the supplier can confirm. There are ${this.expiredBefore(
              moment(utcExpiresAt)
                .add(72, "hours")
                .tz(timeZone)
                .utc(true),
              timeZone
            )} left before the payment window closes.`;
      } else if (currentStatus === "SRB") {
        return cutOff
          ? ` This reservation is ${this.hoursUntil(
              pickupDate,
              timeZone
            )} away from the pickup date and has not been confirmed.`
          : "";
      } else {
        return "";
      }
    },
    getStatusClass(
      currentStatus,
      createdAt,
      statusUpdate,
      pickupDate,
      timeZone,
      rateStatus
    ) {
      let cutOff = this.isWithin72Hours(pickupDate, timeZone);
      if (currentStatus === "NW") {
        let diff = this.getDifference(createdAt) >= 48;
        return this.getStatusClassForNewStatus(cutOff, diff, statusUpdate);
      } else if (currentStatus === "SC") {
        return this.getStatusClassForConfirmedStatus(cutOff, statusUpdate);
      } else if (["SCB", "SBC"].includes(currentStatus)) {
        return "status-cancelled";
      } else if (currentStatus === "SRB") {
        return cutOff ? "status-rejected critical-rejected" : "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(currentStatus)) {
        return "status-started";
      } else if (currentStatus === "JF") {
        return "status-completed";
      } else if (currentStatus === "NS") {
        return "status-noshow";
      } else if (currentStatus === "BI") {
        return "status-draft";
      } else if (currentStatus === "PNDG") {
        return rateStatus ? "status-expired" : "status-draft";
      } else {
        return {};
      }
    },
    getStatusClassForNewStatus(cutOff, diff, statusUpdate) {
      if (cutOff) {
        if (diff) {
          return "status-overdue critical-overdue";
        } else {
          return statusUpdate
            ? "status-reconfirm critical-reconfirmed"
            : "status-new critical-new";
        }
      } else {
        if (diff) {
          return "status-overdue";
        } else {
          return statusUpdate ? "status-reconfirm" : "status-new";
        }
      }
    },
    getStatusClassForConfirmedStatus(cutOff, statusUpdate) {
      if (statusUpdate) {
        return cutOff
          ? "status-reconfirm critical-reconfirmed"
          : "status-reconfirm";
      } else {
        return "status-confirmed";
      }
    },
    getPopoverMessageToReservationInNewStatus(
      cutOff,
      diff,
      statusUpdate,
      createdAt,
      pickupDate,
      timeZone
    ) {
      if (cutOff) {
        if (diff) {
          return `This reservation was created ${this.getCounterTime(
            createdAt
          )} ago and is now ${this.hoursUntil(
            pickupDate,
            timeZone
          )} away from the pickup date without confirmation.`;
        } else {
          return statusUpdate
            ? `This updated reservation is  ${this.hoursUntil(
                pickupDate,
                timeZone
              )} away from the pickup date and still needs to be confirmed.`
            : `This reservation is ${this.hoursUntil(
                pickupDate,
                timeZone
              )} way from the pickup date and still needs to be confirmed.`;
        }
      } else {
        if (diff) {
          return `This reservation has not been confirmed, and it has been ${this.getCounterTime(
            createdAt
          )} since it was created.`;
        } else {
          return statusUpdate
            ? "This reservation has been updated but is not yet confirmed."
            : "";
        }
      }
    },
    getPopoverMessageToReservationInConfirmedStatus(
      statusUpdate,
      cutOff,
      pickupDate,
      timeZone
    ) {
      if (statusUpdate) {
        return cutOff
          ? `This updated reservation is ${this.hoursUntil(
              pickupDate,
              timeZone
            )} away from the pickup date and still needs to be reconfirmed.`
          : "This reservation has been updated and needs to be reconfirmed.";
      } else {
        return "";
      }
    },
    getCounterTime(createdAt) {
      let hours = this.getDifference(createdAt);
      const totalMinutes = Math.floor(hours * 60);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hoursRemaining = Math.floor((totalMinutes % (60 * 24)) / 60);

      return this.getDurationTime(days, hoursRemaining);
    },
    hoursUntil(pickupDate, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let duration = moment.duration(moment(pickupDate).diff(currentDate));
      let hours = Math.floor(duration.asHours());
      const totalMinutes = Math.floor(hours * 60);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hoursRemaining = Math.floor((totalMinutes % (60 * 24)) / 60);

      return this.getDurationTime(days, hoursRemaining);
    },
    expiredBefore(utcExpiresAt, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let duration = moment.duration(moment(utcExpiresAt).diff(currentDate));
      let hours = Math.floor(duration.asHours());
      const totalMinutes = Math.floor(hours * 60);
      const days = Math.floor(totalMinutes / (60 * 24));
      const hoursRemaining = Math.floor((totalMinutes % (60 * 24)) / 60);

      return this.getDurationTime(days, hoursRemaining);
    },
    isWithin72Hours(pickupDate, timeZone) {
      let currentDate = moment()
        .tz(timeZone)
        .startOf("day");
      let thresholdDate = moment()
        .tz(timeZone)
        .add(3, "days")
        .endOf("days");
      return moment(pickupDate).isBetween(currentDate, thresholdDate);
    },
    getDurationTime(days, hours, minutes = 0) {
      let result = "";
      if (days === 1) {
        result += `${days} day `;
      } else if (days > 1) {
        result += `${days} days `;
      }
      if (hours === 1) {
        result += `${hours} hour `;
      } else if (hours > 1) {
        result += `${hours} hours `;
      }
      return result.trim();
    },
    getReservationClass(reservationClass) {
      return reservationClass ? reservationClass : "Transfers";
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getCurrency(reservationClass, service, pricing) {
      if (reservationClass === "Transfers") {
        return {
          code: service ? service.currency_code : "",
          symbol: service ? service.currency_symbol : ""
        };
      } else {
        return {
          code: pricing.currency,
          symbol: this.getCurrenSymbolByCurrency(pricing.currency)
        };
      }
    },
    getSupplierName(reservationClass, supplier) {
      if (reservationClass === "Transfers") {
        return supplier.businessDetails.name;
      } else {
        return null;
      }
    },
    getPaymentReference(reservationClass, payment, paymentReference) {
      if (reservationClass === "Transfers") {
        return payment ? payment.transaction_id : paymentReference;
      } else {
        return null;
      }
    },
    getDriverName(reservationClass, driver) {
      if (reservationClass === "Transfers") {
        return driver
          ? `${driver.person.first_name} ${driver.person.last_name}`
          : null;
      } else {
        return null;
      }
    },
    goToEditReservation(reservation) {
      if (reservation.class === "Transfers") {
        return `/reservations/${reservation._id}`;
      } else {
        return `/reservations/${reservation._id}?productId=${reservation.productId}`;
      }
    },
    getTravelDate(availabilityId) {
      return availabilityId
        ? moment.parseZone(availabilityId).format("DD-MMM-YYYY")
        : "";
    },
    getStartTime(availabilityId) {
      return availabilityId
        ? moment.parseZone(availabilityId).format("hh:mm A")
        : "";
    },
    getContacts(contact, unitItems = []) {
      let paxNumber = unitItems.length;
      return `${contact.fullName} ${
        paxNumber === 1 ? "" : `+ ${paxNumber - 1}`
      }`;
    },
    getTotalCharge(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.gross_price)
        : this.getProductPricing(pricing.retail, pricing.currencyPrecision);
    },
    getNetprice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.net_price)
        : this.getProductPricing(pricing.original, pricing.currencyPrecision);
    },
    getQuotedPrice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.net_price.amount)
        : this.getProductPricing(pricing.original, pricing.currencyPrecision);
    },
    getGrossPrice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.gross_price)
        : this.getProductPricing(pricing.retail, pricing.currencyPrecision);
    },
    getNetProfit(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.net_profit)
        : 0;
    },
    getTotalExtras(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.extras.gross_price)
        : 0;
    },
    getTotalDiscounts(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.discounts)
        : 0;
    },
    getProductPricing(amount, currencyPrecision) {
      let total = amount / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getLabelPax(unitItems = []) {
      let units = unitItems.map(e => e.unit.title);
      return [...new Set(units)]
        .map(item => {
          return `${units.filter(unit => unit === item).length} ${item}`;
        })
        .join(" <br> ");
    },
    getSourceProvider(source) {
      if (source.provider === "RHOMTRIP") {
        return "RhomTrip";
      } else if (source.provider === "VENTRATA") {
        return "Ventrata";
      }
      return "";
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatCategory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else {
        return "Mx.";
      }
    },
    toggleDetails(item, id) {
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
      this.expandedRow =
        this.expandedRow === item.booking_number ? null : item.booking_number;
    },
    isRowExpanded(item) {
      return item._showDetails && this.expandedRow === item.booking_number;
    },
    getHeaderPassengerTable(files = [], transferType) {
      return files
        .filter(file => {
          if (["hourly", "journey"].includes(transferType)) {
            return file.key !== "itinerary";
          } else {
            return true;
          }
        })
        .map(file => {
          if (file.key === "itinerary") {
            file.label = this.getLabelToHeaderTable(transferType);
          }
          return file;
        });
    },
    getLabelToHeaderTable(type) {
      if (["airport", "arrival", "departure"].indexOf(type) > -1) {
        return "Flight N°";
      } else if (type === "station") {
        return "Rail Line";
      } else if (type === "port") {
        return "Cruise Ship";
      } else {
        return "Transport Ref.";
      }
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}\nEmail: ${passenger.email}\n`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    goToPreviousPage() {
      goBack(this);
    },
    /**
     *
     * Booking Action Methods
     */
    openShareReservationsModel(selectedRows = []) {
      const bookings = selectedRows.map(item => item.reservation);
      const validationRules = [
        {
          check: bookings => bookings.length > 50,
          title: "Sharing Limit Reached! ",
          message:
            "Sharing is limited to a maximum of 50 reservations at a time."
        },
        {
          check: hasCanceledBookings,
          title: "Cancelled Reservations",
          message:
            "Some selected reservations have been cancelled. Please check their status."
        },
        {
          check: hasDraftBookings,
          title: "Draft Reservations",
          message:
            "Some selected reservations are in draft status. Please confirm them before sharing."
        },
        {
          check: hasExpiredBookings,
          title: "Expired Reservations",
          message:
            "Some selected reservations have expired. Please check their status."
        },
        {
          check: hasCompletedBookings,
          title: "Completed Reservations",
          message:
            "Some selected reservations are completed. Please check their status."
        },
        {
          check: hasExperiencesBookings,
          title: "Experience Reservations",
          message:
            "Some selected reservations are experiences. Please check their status."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: rule.title,
            message: rule.message,
            icon: "flaticon-warning"
          });
          return;
        }
      }
      this.selectedReservationsToShare = selectedRows;
      this.showShareReservations = true;
    },
    closeShareReservationsModal() {
      this.selectedReservationsToShare = [];
      this.showShareReservations = false;
    },
    async handlerSendPaymentLink(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to request payment for one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to request payment for one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to request payment for one or more reservations with an expired rate. Please recalculate the rates for these pending reservations before sending the payment link."
        },
        {
          check: hasDraftBookings,
          message:
            "You are trying to request payment for one or more reservations that have not been completed"
        },
        {
          check: isSameUserForAllBookings,
          message: "Selected reservations must have the same customer name"
        },
        {
          check: bookings => bookings.length > 15,
          message:
            "You can only send payment links for a maximum of 15 reservations at a time."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "Payment link could not be sent!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      const [booking] = bookings;
      let { customer, agent } = booking;
      let client = agent ? agent : customer;
      let userId = this.getUserId(client);
      let userRole = client.type;
      if (!userId && !userRole) {
        this.$notify({
          type: "warning",
          title: "User Identification Error",
          message:
            "An error occurred while identifying the user. Please try again.",
          icon: "flaticon-warning-1"
        });
        return;
      }

      let payload = {
        userId: userId,
        userRole: userRole,
        reservations: bookings.map(booking => booking._id)
      };
      await sendPaymentLink(payload, callback);
    },
    async sendPaymentLinkToCustomer(payload) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.sendPaymentLink(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.send) {
          this.$notify({
            type: "success",
            title: "Payment Link Sent!",
            message:
              "Your payment email link has been sent to customer successfully",
            icon: "flaticon-remove"
          });
          this.get(
            false,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Payment link was not sent!",
            message: "Please contact support via email",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "Please contact support via email",
          "Payment link was not sent!"
        );
      }
    },
    async handlerCancelReservation(
      bookingId,
      pickupDate,
      timeZone,
      cancellationPolicy,
      callback
    ) {
      const utcNow = moment.tz(timeZone).utc(true);
      let refundEligibility = resolveRefundEligibility(
        utcNow,
        pickupDate,
        cancellationPolicy
      );
      await cancelBooking(bookingId, refundEligibility, callback);
    },
    async cancelReservationById(reservationId, reason, refundEligibility) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.canlcelReservationById(
          reservationId,
          reason,
          refundEligibility,
          this.sesion.token
        );
        this.setLoad(false);
        let canceled = data.data;
        if (!canceled) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async confirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confimedReservations(
          reservationId,
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.confirmed) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async updateBookingStatus(reservationId, status, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.changeRservationStatus(
          reservationId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been completed successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be completed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async handlerMarkReservationsAsPaid(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to pay one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to pay one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to pay one or more reservations with an expired rate."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "The Reservations cannot be Paid!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      await markReservationsAsPaid(bookings, callback);
    },
    async markReservationsAsPaidById(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.markReservationsAsPaid(
          reservations,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let { payments } = data.data;
          if (payments.reduce((a, b) => a && b, true)) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Reservations has been Paid",
              icon: "flaticon-check-3"
            });
            this.get(
              false,
              this.limit,
              this.currentPage,
              this.queryTemp ? this.queryTemp : this.query
            );
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "One or more reservations could not be paid",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Paid",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Paid");
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async duplicateBookingById(bookingId, populate) {
      try {
        let { data } = await ReservationsAPI.getReservation(
          bookingId,
          populate,
          this.sesion.token
        );
        if (data.status) {
          let booking = removeTransferExcludedAttributes(
            lodash.cloneDeep(data.data)
          );
          this.setDuplicatedReservation(booking);
          this.$router.push("/reservations/new");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Voucher(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadTickets(bookingId, client, reference) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDFTickets(
          bookingId,
          client,
          "ALL",
          null
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Tickets(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async deleteBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservation(
          bookingId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async bulkDeleteBookingsByIds(bookings = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservationMany(
          bookings,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async otaConfirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaConfirmReservationById(
          reservationId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.confirmed) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async otaCancelBookingById(bookingId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaCancelReservationById(
          bookingId,
          { reason: reason },
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.canceled) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Cancelled",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Cancelled");
      }
    },
    goToNewQuote() {
      this.$router.push("/quotes/new");
    },
    async uploadcsvFile() {
      this.$refs.csvFileInput.value = "";
      this.$refs.csvFileInput.click();
    },
    async handleCsvFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      try {
        this.setLoad(true);
        const { data } = await ReservationsAPI.bulkCreateTransferReservations(
          file,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Reservations Imported!",
            message: "The CSV file was uploaded and processed successfully.",
            icon: "flaticon-check-1"
          });
          this.get(
            false,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
        } else {
          const [error] = data.error || [];
          const errorMessage =
            error && error.row
              ? `${error.message}. Please check the file on row ${error.row} and try again.`
              : error.message;

          this.$notify({
            type: error ? "warning" : "danger",
            title: "Import Failed!",
            message: errorMessage
              ? errorMessage
              : "The file could not be processed. Please check the format and try again.",
            icon: error ? "flaticon-warning-1" : "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "Please contact support via email",
          "Import Failed!"
        );
      }
    },
    async downloadEventsTemplate(ids = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportEventsTemplate(
          ids,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `event.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data wasn't download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        const { data } = error.response || {};
        const errorMessage =
          data && data.error && data.error.length ? data.error[0].message : "";
        this.$notify({
          type: "danger",
          title: "Error!",
          message: errorMessage || "The data wasn't download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    changeFirstBookings(status) {
      this.filters.firstBooking = this.filters.firstBookingSwitch ? "true" : "";
    },
    ...mapActions([
      "getSesion",
      "getOperatorsOptions",
      "getReservations",
      "getLimit"
    ]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setTempPagination",
      "setDuplicatedReservation",
      "setSettings"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
    clearTimeout(this.timeoutId);
  },
  computed: {
    reservations() {
      try {
        let reservations = this.responseReservations.docs || [];
        return reservations.map(reservation => {
          let reservationClass = this.getReservationClass(reservation.class);
          return {
            //Commons
            booking_number: reservation.booking_number,
            customer: this.getCustomerName(
              reservation.agent ? reservation.agent : reservation.customer
            ),
            passengers: reservation.passengers,
            payment: this.getStatusPayment(
              reservation.payment,
              reservation.payment_type,
              reservation.send_payment_link,
              reservation.status
            ),
            reservation_reference: reservation.booking_reference,
            deal_number: reservation.deal_number,
            invoice_n: reservation.invoice_number,
            payment_reference: this.getPaymentReference(
              reservationClass,
              reservation.payment,
              reservation.payment_reference
            ),
            status: this.formatStatus(reservation.status),

            //Transfer
            pickup_date: reservation.pickup_date,
            supplier: this.getSupplierName(
              reservationClass,
              reservation.supplier
            ),
            totalCharge: this.getTotalCharge(
              reservationClass,
              reservation.pricing
            ),
            netPrice: this.getNetprice(reservationClass, reservation.pricing),
            quotedPrice: this.getQuotedPrice(
              reservationClass,
              reservation.pricing
            ),
            grossPrice: this.getGrossPrice(
              reservationClass,
              reservation.pricing
            ),
            netProfit: this.getNetProfit(reservationClass, reservation.pricing),
            totalExtras: this.getTotalExtras(
              reservationClass,
              reservation.pricing
            ),
            totalDiscounts: this.getTotalDiscounts(
              reservationClass,
              reservation.pricing
            ),
            currency: this.getCurrency(
              reservationClass,
              reservation.service,
              reservation.pricing
            ),
            driver: this.getDriverName(reservationClass, reservation.driver),
            to: reservationClass === "Transfers" ? reservation.to : "",
            from: reservationClass === "Transfers" ? reservation.from : "",
            typeTransfer:
              reservationClass === "Transfers" ? reservation.type : "",
            passengersCount:
              reservationClass === "Transfers"
                ? reservation.passengersCount
                : "",
            flightNumber:
              reservationClass === "Transfers" ? reservation.flight_number : "",
            commission: reservation.commissions
              ? reservation.commissions.platform.amount
              : 0,
            class: reservationClass,
            referredBy: reservation.referredBy,
            stripeFee: reservation.commissions.payment_processor.amount || 0,
            reservation: reservation
          };
        });
      } catch (error) {
        return [];
      }
    },
    ...mapGetters([
      "responseReservations",
      "sesion",
      "userRole",
      "operatorSelections",
      "paginationLimit",
      "tempPagination",
      "settings",
      "customerOptions"
    ]),
    canUserCreate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CREATE");
    },
    canUserDelete() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "DELETE");
    },
    canUserMarkBookingAsPaid() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "MARK_AS_PAID");
    },
    canUserSendPaymentLink() {
      return isUserAuthorized(
        "RESERVATIONS",
        this.userRole,
        "SEND_PAYMENT_LINK"
      );
    },
    canUserChangeStatus() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CHANGE_STATUS");
    },
    canUserExport() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "EXPORT");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setTempPagination({
      currentPage: this.currentPage,
      query: this.query,
      queryTemp: this.queryTemp,
      filteredTabStatus: this.filterStatus,
      limit: this.paginationLimit,
      status: true
    });
    next();
  }
};
</script>
